import { Environment } from '@onwardtravelsolutions/package-react/Enums';
import { createContext } from 'react';
import { ReCaptcha } from '../Types';

interface EnvironmentValue {
        recaptcha: ReCaptcha;
        environment: Environment;
        urls: {
                dashboard: string;
                gateway: string;
                home: string;
                login: string;
        };
}

export default createContext<EnvironmentValue | null>(null);
